<template>
  <div class="submit">
    <div class="phone" v-show="!isPc">
      <!-- 业务类型和机动车归属地, -->
      <div v-for="(item, index) in selectArr0" :key="'select' + index">
        <p
          :class="currentFocus && currentFocus == index + 11 ? 'active' : ''"
          :hidden="
            (item.name == '机动车归属地' && selectArr0[0].typeId != '0') ||
            (item.name == '审核部门' && selectArr0[1].typeId != '1')
          "
        >
          {{ item.name
          }}<span class="red" :hidden="item.name == '销售4S店'">*</span>
        </p>
        <input
          type="text"
          v-if="item.name == '机动车归属地'"
          v-show="selectArr0[0].typeId == '0'"
          :class="currentFocus && currentFocus == index + 11 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 11"
          @blur="currentFocus = ''"
          readonly
          @click="select(index, 'front')"
        />
        <input
          type="text"
          v-else-if="item.name == '审核部门'"
          v-show="selectArr0[1].typeId == '1'"
          :class="currentFocus && currentFocus == index + 11 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 11"
          @blur="currentFocus = ''"
          readonly
          @click="select(index, 'front')"
        />
        <input
          type="text"
          v-else
          :class="currentFocus && currentFocus == index + 11 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 11"
          @blur="currentFocus = ''"
          readonly
          @click="select(index, 'front')"
        />
      </div>
      <div
        v-for="(item, index) in inputArr"
        v-show="!(selectArr0[0].typeId == '0' && selectArr0[1].typeId == '1')"
        :key="'phone' + index"
      >
        <p :class="currentFocus && currentFocus == index + 1 ? 'active' : ''">
          {{ item.name }}<span class="red">*</span>
        </p>
        <input
          type="text"
          v-if="item.name == '生产(制造)年月'"
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 1"
          @blur="currentFocus = ''"
          readonly
          @click="timeShow = true"
          :placeholder="item.name"
        />
        <el-autocomplete
          v-else-if="item.name == '提交人或4S店名称'"
          v-model="item.model"
          :fetch-suggestions="querySearch_mc"
          @select="handleSelect"
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          @focus="currentFocus = index + 1"
          @blur="lostFocus(item)"
          @keyup="change(index)"
        ></el-autocomplete>
        <el-autocomplete
          v-else-if="item.name == '所有人身份证号或4S店统一社会信用代码'"
          v-model="item.model"
          :fetch-suggestions="querySearch_dm"
          @select="handleSelect"
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          @focus="currentFocus = index + 1"
          @blur="lostFocus(item)"
          @keyup="change(index)"
        ></el-autocomplete>
        <el-autocomplete
          v-else-if="item.name == '车辆生产厂家'"
          style="marginbottom: 5px"
          v-model="item.model"
          :fetch-suggestions="querySearch_cj"
          @select="handleSelect"
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          @focus="currentFocus = index + 1"
          @blur="lostFocus(item)"
          @keyup="change(index)"
        ></el-autocomplete>
        <input
          type="text"
          v-else
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 1"
          @blur="currentFocus = ''"
          @keyup="change(index, item)"
        />
      </div>
      <div
        v-for="(item, index) in selectArr"
        v-show="!(selectArr0[0].typeId == '0' && selectArr0[1].typeId == '1')"
        :key="'select' + index"
      >
        <p :class="currentFocus && currentFocus == index + 11 ? 'active' : ''">
          {{ item.name
          }}<span class="red" :hidden="item.name == '销售4S店'">*</span>
        </p>
        <input
          type="text"
          v-if="item.name == '销售4S店'"
          :class="currentFocus && currentFocus == index + 11 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 11"
          @blur="currentFocus = ''"
        />
        <!-- <div v-else-if="item.name=='燃料种类'" class="rlzl">
          <input type="text" :class="currentFocus&&currentFocus==index+11?'active':''" v-model="item.model" @focus="currentFocus=index+11" @blur="currentFocus=''" readonly @click="select(index)">
          <input type="text" :class="currentFocus&&currentFocus==index+11?'active':''" v-model="item.model" @focus="currentFocus=index+11" @blur="currentFocus=''" readonly @click="select(index)">
          <input type="text" :class="currentFocus&&currentFocus==index+11?'active':''" v-model="item.model" @focus="currentFocus=index+11" @blur="currentFocus=''" readonly @click="select(index)">
        </div> -->
        <input
          type="text"
          v-else
          :class="currentFocus && currentFocus == index + 11 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 11"
          @blur="currentFocus = ''"
          readonly
          @click="select(index)"
        />
      </div>

      <div
        v-for="(item, index) in inputArr0"
        v-show="selectArr0[0].typeId == '0' && selectArr0[1].typeId == '1'"
        :key="'phone' + index"
      >
        <p :class="currentFocus && currentFocus == index + 1 ? 'active' : ''">
          {{ item.name }}<span class="red">*</span>
        </p>
        <input
          type="text"
          v-if="item.name == '生产(制造)年月'"
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 1"
          @blur="currentFocus = ''"
          readonly
          @click="timeShow = true"
          :placeholder="item.name"
        />
        <input
          v-else
          type="text"
          :class="currentFocus && currentFocus == index + 1 ? 'active' : ''"
          v-model="item.model"
          @focus="currentFocus = index + 1"
          @blur="currentFocus = ''"
          @keyup="change(index, item)"
        />
      </div>
      <van-popup v-model="timeShow" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="timeConfirm"
          @cancel="timeShow = !timeShow"
        />
      </van-popup>
      <van-popup v-model="selectShow" position="bottom">
        <van-picker
          :columns="columns"
          show-toolbar
          @cancel="cancel"
          @confirm="onConfirm"
          v-show="ismc"
          value-key="mc"
        />
        <van-picker
          :columns="columns"
          show-toolbar
          @cancel="cancel"
          @confirm="onConfirm"
          v-show="!ismc"
          value-key="bmmc"
        />
      </van-popup>
      <div class="upload" v-show="!(selectArr0[0].typeId == '0')">
        <p v-show="selectArr0[0].typeId == '0'">
          机动车登记证书
          <span style="color: red">(请拍摄含有机动车信息的那一页)</span>
        </p>
        <div class="img" v-show="selectArr0[0].typeId == '0'">
          <div v-show="!imgList[0].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[0].imageUrl"
            :src="imgList[0].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '0')"
            accept="image/*"
          />
        </div>
        <p v-show="selectArr0[0].typeId == '0'">机动车铭牌</p>
        <div class="img" v-show="selectArr0[0].typeId == '0'">
          <div v-show="!imgList[1].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[1].imageUrl"
            :src="imgList[1].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '1')"
            accept="image/*"
          />
        </div>
        <p v-show="selectArr0[0].typeId == '2'">进口凭证</p>
        <div class="img" v-show="selectArr0[0].typeId == '2'">
          <div v-show="!imgList[2].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[2].imageUrl"
            :src="imgList[2].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '2')"
            accept="image/*"
          />
        </div>
        <p v-show="selectArr0[0].typeId == '2'">随车清单正面</p>
        <div class="img" v-show="selectArr0[0].typeId == '2'">
          <div v-show="!imgList[3].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[3].imageUrl"
            :src="imgList[3].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '3')"
            accept="image/*"
          />
        </div>
        <p v-show="selectArr0[0].typeId == '2'">随车清单反面</p>
        <div class="img" v-show="selectArr0[0].typeId == '2'">
          <div v-show="!imgList[4].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[4].imageUrl"
            :src="imgList[4].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '4')"
            accept="image/*"
          />
        </div>
      </div>
      <div class="upload" v-show="selectArr0[0].typeId == '0'">
        <p v-show="selectArr0[0].typeId == '0'">
          产证 <span style="color: red"></span>
        </p>
        <div class="img" v-show="selectArr0[0].typeId == '0'">
          <div v-show="!imgList[0].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[0].imageUrl"
            :src="imgList[0].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '0')"
            accept="image/*"
          />
        </div>
        <p v-show="selectArr0[0].typeId == '0'">铭牌</p>
        <div class="img" v-show="selectArr0[0].typeId == '0'">
          <div v-show="!imgList[1].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[1].imageUrl"
            :src="imgList[1].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '1')"
            accept="image/*"
          />
        </div>
        <p v-show="selectArr0[0].typeId == '0'">
          环保清单(17年1月1日后) <span style="color: red"></span>
        </p>
        <div class="img" v-show="selectArr0[0].typeId == '0'">
          <div v-show="!imgList[2].imageUrl" class="wind100">
            <img src="../assets/upload.png" class="up" alt="" />
            <span>点击上传图片</span>
          </div>
          <img
            v-show="imgList[2].imageUrl"
            :src="imgList[2].imageUrl"
            alt=""
            class="aleade"
          />
          <input
            type="file"
            class="file"
            @change="picRead($event, '2')"
            accept="image/*"
          />
        </div>
      </div>
      <button @click="back" class="btn">返回</button>
      <button @click="submit" class="btn">提交</button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
const httpForm = axios.create({
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
export default {
  name: "submit",
  data() {
    return {
      isPc: false,
      name: "",
      sjhm: "",
      currentFocus: "",
      currentDate: "",
      timeShow: false,
      selectShow: false,
      selectArr0: [
        {
          name: "业务类型",
          model: "",
          typeId: "",
          data: [
            { dm: "2", mc: "进口新车注册登记类" },
            { dm: "0", mc: "外地车转入注册登记类" },
          ],
        },
        {
          name: "机动车归属地",
          model: "",
          typeId: "",
          data: [
            { dm: "0", mc: "省内" },
            { dm: "1", mc: "省外" },
          ],
        },
        { name: "审核部门", model: "", typeId: "", data: [] },
      ],
      type: "front",
      // pc端
      inputArr: [
        { name: "提交人或4S店名称", model: "" },
        { name: "手机号", model: "" },
        {
          name: "所有人身份证号或4S店统一社会信用代码",
          model: "",
          isUpper: "true",
        },
        { name: "车架号", model: "", isUpper: "true" },
        { name: "发动机号", model: "", isUpper: "true" },
        { name: "发动机型号", model: "", isUpper: "true" },
        { name: "整车型号", model: "" },
        { name: "车辆生产厂家", model: "" },
        { name: "生产(制造)年月", model: "" },
        { name: "随车清单编号", model: "" },
      ],
      inputArr0: [
        { name: "车架号", model: "", isUpper: "true" },
        { name: "生产(制造)年月", model: "" },
        { name: "整车型号", model: "" },
        { name: "发动机型号", model: "", isUpper: "true" },
      ],
      selectArr: [
        { name: "燃料种类", model: "", typeId: "", data: [] },
        { name: "审核部门", model: "", typeId: "", data: [] },
      ],
      columns: [],
      imgList: [
        { imageUrl: "", image: "" },
        { imageUrl: "", image: "" },
        { imageUrl: "", image: "" },
        { imageUrl: "", image: "" },
        { imageUrl: "", image: "" },
        { imageUrl: "", image: "" },
      ],
      currentSellectindex: 0,
      ismc: true,
      rlzlList: [],
      minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 50)), // 最早可以选择50年前
      maxDate: new Date(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      restaurants_mc: [],
      restaurants_dm: [],
      restaurants_cj: [],
    };
  },
  methods: {
    // 下拉框打开
    select(index, type) {
      console.log(index);
      if (type == "front") {
        this.type = "front";
        this.columns = this.selectArr0[index].data;
        this.currentSellectindex = index;
        console.log(this.columns);
        if (index == 2) {
          this.ismc = false;
        } else {
          this.ismc = true;
        }
        return (this.selectShow = true);
      }
      this.type = "";
      if (index == 1) {
        this.ismc = false;
      } else {
        this.ismc = true;
      }
      this.columns = this.selectArr[index].data;
      this.currentSellectindex = index;
      this.selectShow = true;
    },
    // 指定输入框转大写  并把随车清单正则加空格
    change(index, item) {
      console.log(item.name, item.model, this.inputArr[6].model);
      if (this.inputArr[index].isUpper) {
        this.inputArr[index].model = this.inputArr[index].model.toUpperCase();
      }
      if (this.inputArr0[index].isUpper) {
        this.inputArr0[index].model = this.inputArr0[index].model.toUpperCase();
      }
      if (item.name == "随车清单编号") {
        // console.log('这是随车,')
        if (item.model.length == 3) {
          if (/\w{2} /.test(this.inputArr[index].model)) {
            return;
          }
          this.inputArr[index].model = this.inputArr[index].model.replace(
            /(.{2})/g,
            "$1 "
          );
        }
        if (item.model.length == 6) {
          if (/.{5} /.test(this.inputArr[index].model)) {
            return;
          }
          this.inputArr[index].model = this.inputArr[index].model.replace(
            /(.{5})/g,
            "$1 "
          );
        }
        if (item.model.length == 9) {
          if (/.{8} /.test(this.inputArr[index].model)) {
            return;
          }
          this.inputArr[index].model = this.inputArr[index].model.replace(
            /(.{8})/g,
            "$1 "
          );
        }
        if (item.model.length == 12) {
          if (/.{11} /.test(this.inputArr[index].model)) {
            return;
          }
          this.inputArr[index].model = this.inputArr[index].model.replace(
            /(.{11})/g,
            "$1 "
          );
        }
        if (item.model.length == 23) {
          if (/.{22} /.test(this.inputArr[index].model)) {
            return;
          }
          this.inputArr[index].model = this.inputArr[index].model.replace(
            /(.{22})/g,
            "$1 "
          );
        }
        if (item.model.length > 29) {
          this.inputArr[index].model = this.inputArr[index].model.replace(
            /(.{29})(.*)/g,
            "$1"
          );
        }
      }
    },
    // 取消
    cancel() {
      this.selectShow = false;
    },
    // 移动端select选中
    onConfirm(value) {
      console.log(value);
      if (this.type == "front") {
        this.selectArr0[this.currentSellectindex].model = value.mc;
        this.selectArr0[this.currentSellectindex].typeId = value.dm;
        if (!this.ismc) {
          this.selectArr0[this.currentSellectindex].model = value.bmmc;
          this.selectArr0[this.currentSellectindex].typeId = value.deptid;
        }
        return (this.selectShow = false);
      }
      if (this.currentSellectindex > 0) {
        this.selectArr[this.currentSellectindex].model = this.ismc
          ? value.mc
          : value.bmmc;
        this.selectArr[this.currentSellectindex].typeId = this.ismc
          ? value.dm
          : value.deptid;
      } else {
        let mc1 = value[0].dm ? value[0].mc : "";
        let mc2 = value[1].dm ? value[1].mc : "";
        let mc3 = value[2].dm ? value[2].mc : "";
        let mc;
        if (mc1 == mc2) {
          mc2 = "";
        }
        if (mc1 == mc3) {
          mc3 = "";
        }
        if (mc2 == mc3) {
          mc3 = "";
        }
        mc = mc1 + mc2 + mc3;
        this.selectArr[this.currentSellectindex].model = mc;
        this.selectArr[this.currentSellectindex].typeId =
          value[0].dm + value[1].dm + value[2].dm;
      }
      this.selectShow = false;
    },
    // 返回
    back() {
      window.history.go(-1);
    },
    // 提交
    submit() {
      var that = this;
      let ywlx = this.isPc
        ? this.selectArr0[0].model
        : this.selectArr0[0].typeId;

      let jdcgsd = this.isPc
        ? this.selectArr0[1].model
        : this.selectArr0[1].typeId;
      if (ywlx == "0") {
        return this.submit0();
      }
      let shbm = this.isPc ? this.selectArr[1].model : this.selectArr[1].typeId;
      let rlzl = this.selectArr[0].model;
      let rlzl1 =
        (rlzl[0] ? rlzl[0] : "") +
        (rlzl[1] ? rlzl[1] : "") +
        (rlzl[2] ? rlzl[2] : "");
      let rlzl2 = this.isPc ? rlzl1 : this.selectArr[0].typeId;
      if (!this.inputArr[0].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入提交人或4S店名称")
          : this.$root.$children[0].vueAlert("请输入提交人或4S店名称");
      }
      if (!this.inputArr[1].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入手机号码")
          : this.$root.$children[0].vueAlert("请输入手机号码");
      }
      var phone = /^1[3-9][0-9]\d{8}$/;
      if (!phone.test(this.inputArr[1].model)) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入正确的手机号码")
          : this.$root.$children[0].vueAlert("请输入正确的手机号码");
      }
      if (!this.inputArr[2].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1(
              "请输入身份证明号码或社会信用代码"
            )
          : this.$root.$children[0].vueAlert(
              "请输入身份证明号码或社会信用代码"
            );
      }
      if (!this.inputArr[3].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入车架号")
          : this.$root.$children[0].vueAlert("请输入车架号");
      }
      if (this.inputArr[3].model.length != 17) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入17位车架号")
          : this.$root.$children[0].vueAlert("请输入17位车架号");
      }
      if (!this.inputArr[4].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入发动机号")
          : this.$root.$children[0].vueAlert("请输入发动机号");
      }
      if (!this.inputArr[5].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入发动机型号")
          : this.$root.$children[0].vueAlert("请输入发动机型号");
      }
      if (!this.inputArr[6].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入整车型号")
          : this.$root.$children[0].vueAlert("请输入整车型号");
      }
      if (!this.inputArr[7].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入车辆生产厂家")
          : this.$root.$children[0].vueAlert("请输入车辆生产厂家");
      }
      if (!this.inputArr[8].model) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入生产(制造)年月")
          : this.$root.$children[0].vueAlert("请输入生产(制造)年月");
      }
      if (!this.inputArr[9].model && ywlx == 2) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请输入随车清单编号")
          : this.$root.$children[0].vueAlert("请输入随车清单编号");
      }
      if (!rlzl2) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请选择燃料种类")
          : this.$root.$children[0].vueAlert("请选择燃料种类");
      }
      if (!ywlx) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请选择业务类型")
          : this.$root.$children[0].vueAlert("请选择业务类型");
      }
      // if(ywlx==2){
      //    if(!this.imgList[2].image){
      //       return this.isPc?this.$root.$children[0].vueAlert1('请上传进口凭证'):this.$root.$children[0].vueAlert('请上传进口凭证');
      //     }
      //     if(!this.imgList[3].image){
      //       return this.isPc?this.$root.$children[0].vueAlert1('请上传随车清单正面'):this.$root.$children[0].vueAlert('请上传随车清单正面');
      //     }
      //     if(!this.imgList[4].image){
      //       return this.isPc?this.$root.$children[0].vueAlert1('请上传随车清单反面'):this.$root.$children[0].vueAlert('请上传随车清单反面');
      //     }
      // }
      if (!shbm) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请选择审核部门")
          : this.$root.$children[0].vueAlert("请选择审核部门");
      }
      // if(!this.imgList[1].image){
      //   return this.isPc?this.$root.$children[0].vueAlert1('请上传机动车铭牌照片'):this.$root.$children[0].vueAlert('请上传机动车铭牌照片');
      // }
      let ccrq = this.isPc
        ? this.$root.$children[0].timeFomat(
            "yyyy-MM-dd",
            this.inputArr[8].model
          )
        : this.inputArr[8].model;
      var formData = new FormData();
      if (this.imgList[0].image) {
        formData.append("picDjzs", this.imgList[0].image);
      }
      if (this.imgList[1].image) {
        formData.append("picJdcmp", this.imgList[1].image);
      }
      if (this.imgList[2].image) {
        formData.append("picJkpz", this.imgList[2].image);
      }
      if (this.imgList[3].image) {
        formData.append("picScqd", this.imgList[3].image);
      }
      if (this.imgList[4].image) {
        formData.append("picScqd2", this.imgList[4].image);
      }
      this.$parent.showLoading();
      let url =
        "fLow/submit?tjr=" +
        this.inputArr[0].model +
        "&sjhm=" +
        this.inputArr[1].model +
        "&syr=" +
        this.inputArr[0].model +
        "&sfzmhm=" +
        this.inputArr[2].model +
        "&clsbdh=" +
        this.inputArr[3].model +
        "&fdjh=" +
        this.inputArr[4].model +
        "&fdjxh=" +
        this.inputArr[5].model +
        "&zcxh=" +
        this.inputArr[6].model +
        "&sccs=" +
        this.inputArr[7].model +
        "&scqdbh=" +
        this.inputArr[9].model +
        "&ccrq=" +
        ccrq +
        "&rlzl=" +
        rlzl2 +
        "&ywlx=" +
        ywlx +
        "&xs4s=" +
        "xs4s" +
        "&shbm=" +
        shbm;
      url = encodeURI(encodeURI(url).replace(/\+/g, "%2B"));
      // console.log(url)
      // console.log("fLow/submit?tjr="+this.inputArr[0].model)
      // console.dir(formData)
      httpForm({
        method: "post",
        url: decodeURI(url),
        data: formData,
      })
        .then((result) => {
          that.$toast.clear();
          var response = result.data;
          if (response.status != "1") {
            if (that.isPc) {
              return that.$root.$children[0].vueAlert1(response.msg);
            } else {
              return that.$root.$children[0].vueAlert(response.msg);
            }
          }
          // localStorage.setItem("cxm", response.data.cxm);
          localStorage.setItem("ywlx", ywlx);
          // localStorage.setItem("cxm", response.data.cxm);
          this.$router.push("result");
        })
        .catch((err) => {
          console.log(err);
          that.$toast.clear();
        });
    },
    submit0() {
      console.log("submit0");
      var that = this;
      let ywlx = this.isPc
        ? this.selectArr0[0].model
        : this.selectArr0[0].typeId;
      let jdcgsd = this.isPc
        ? this.selectArr0[1].model
        : this.selectArr0[1].typeId;
      let shbm = this.isPc
        ? this.selectArr0[2].model
        : this.selectArr0[2].typeId;
      let ccrq = this.isPc
        ? this.$root.$children[0].timeFomat(
            "yyyy-MM-dd",
            this.inputArr0[1].model
          )
        : this.inputArr0[1].model;
      let rlzl;
      let rlzl1;
      let rlzl2;
      // 外地车表单验证
      console.log(jdcgsd);
      // 省内
      if (jdcgsd === "0") {
        if (!this.inputArr[3].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入车架号3")
            : this.$root.$children[0].vueAlert("请输入车架号4");
        }
        if (this.inputArr[3].model.length != 17) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入17位车架号")
            : this.$root.$children[0].vueAlert("请输入17位车架号");
        }
        if (!this.inputArr[5].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入发动机型号")
            : this.$root.$children[0].vueAlert("请输入发动机型号");
        }
        if (!this.inputArr[6].model) {
          console.log(this.inputArr, 7788);
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入整车型号")
            : this.$root.$children[0].vueAlert("请输入整车型号");
        }
        if (!this.inputArr[8].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入生产(制造)年月")
            : this.$root.$children[0].vueAlert("请输入生产(制造)年月");
        }
      }
      if (jdcgsd === "1") {
        if (!this.inputArr0[0].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入车架号")
            : this.$root.$children[0].vueAlert("请输入车架号");
        }
        if (this.inputArr0[0].model.length != 17) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入17位车架号")
            : this.$root.$children[0].vueAlert("请输入17位车架号");
        }
        if (!this.inputArr0[1].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入生产(制造)年月")
            : this.$root.$children[0].vueAlert("请输入生产(制造)年月");
        }
        if (!this.inputArr0[2].model) {
          console.log(this.inputArr, 7788);
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入整车型号")
            : this.$root.$children[0].vueAlert("请输入整车型号");
        }
        if (!this.inputArr0[3].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入发动机型号")
            : this.$root.$children[0].vueAlert("请输入发动机型号");
        }
      }

      if (!ywlx) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请选择业务类型")
          : this.$root.$children[0].vueAlert("请选择业务类型");
      }
      if (!jdcgsd) {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请选择机动车所属地")
          : this.$root.$children[0].vueAlert("请选择机动车所属地");
      }
      if (!shbm && jdcgsd == "1") {
        return this.isPc
          ? this.$root.$children[0].vueAlert1("请选择审核部门")
          : this.$root.$children[0].vueAlert("请选择审核部门");
      }
      if (jdcgsd == "0") {
        rlzl = this.selectArr[0].model;
        rlzl1 =
          (rlzl[0] ? rlzl[0] : "") +
          (rlzl[1] ? rlzl[1] : "") +
          (rlzl[2] ? rlzl[2] : "");
        rlzl2 = this.isPc ? rlzl1 : this.selectArr[0].typeId;
        if (!this.inputArr[0].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入提交人或4S店名称")
            : this.$root.$children[0].vueAlert("请输入提交人或4S店名称");
        }
        if (!this.inputArr[1].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入手机号码")
            : this.$root.$children[0].vueAlert("请输入手机号码");
        }
        var phone = /^1[3-9][0-9]\d{8}$/;
        if (!phone.test(this.inputArr[1].model)) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入正确的手机号码")
            : this.$root.$children[0].vueAlert("请输入正确的手机号码");
        }
        if (!this.inputArr[2].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1(
                "请输入身份证明号码或社会信用代码"
              )
            : this.$root.$children[0].vueAlert(
                "请输入身份证明号码或社会信用代码"
              );
        }
        if (!this.inputArr[3].model) {
          console.log(this.inputArr[3]);
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入车架号")
            : this.$root.$children[0].vueAlert("请输入车架号");
        }
        if (this.inputArr[3].model.length != 17) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入17位车架号")
            : this.$root.$children[0].vueAlert("请输入17位车架号");
        }
        if (!this.inputArr[4].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入发动机号")
            : this.$root.$children[0].vueAlert("请输入发动机号");
        }
        if (!this.inputArr[5].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入发动机型号")
            : this.$root.$children[0].vueAlert("请输入发动机型号");
        }
        if (!this.inputArr[6].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入整车型号")
            : this.$root.$children[0].vueAlert("请输入整车型号");
        }
        if (!this.inputArr[7].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入车辆生产厂家")
            : this.$root.$children[0].vueAlert("请输入车辆生产厂家");
        }
        if (!this.inputArr[8].model) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入生产(制造)年月")
            : this.$root.$children[0].vueAlert("请输入生产(制造)年月");
        }
        if (!this.inputArr[9].model && ywlx == 2) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请输入随车清单编号")
            : this.$root.$children[0].vueAlert("请输入随车清单编号");
        }
        if (!rlzl2) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请选择燃料种类")
            : this.$root.$children[0].vueAlert("请选择燃料种类");
        }
        shbm = this.isPc ? this.selectArr[1].model : this.selectArr[1].typeId;
        if (!shbm) {
          return this.isPc
            ? this.$root.$children[0].vueAlert1("请选择审核部门")
            : this.$root.$children[0].vueAlert("请选择审核部门");
        }
        ccrq = this.isPc
          ? this.$root.$children[0].timeFomat(
              "yyyy-MM-dd",
              this.inputArr[8].model
            )
          : this.inputArr[8].model;
      }
      var formData = new FormData();
      if (this.imgList[0].image) {
        // 产证
        formData.append("picDjzs", this.imgList[0].image);
      }
      if (this.imgList[1].image) {
        // 铭牌
        formData.append("picLshp", this.imgList[1].image);
      }
      if (this.imgList[2].image) {
        // 环保清单
        formData.append("picScqd", this.imgList[2].image);
      }
      this.$parent.showLoading();
      let url;
      if (jdcgsd == "1") {
        // 省外
        url =
          "fLow/submitOutside?clsbdh=" +
          this.inputArr0[0].model +
          "&ywlx=" +
          ywlx +
          "&xs4s=" +
          "xs4s" +
          "&shbm=" +
          shbm +
          "&clssd=" +
          jdcgsd +
          "&ccrq=" +
          ccrq +
          "&zcxh=" +
          this.inputArr0[2].model +
          "&fdjxh=" +
          this.inputArr0[3].model;
      } else {
        // 省内
        rlzl = this.selectArr[0].model;
        rlzl1 =
          (rlzl[0] ? rlzl[0] : "") +
          (rlzl[1] ? rlzl[1] : "") +
          (rlzl[2] ? rlzl[2] : "");
        rlzl2 = this.isPc ? rlzl1 : this.selectArr[0].typeId;
        url =
          "fLow/submitOutside?tjr=" +
          this.inputArr[0].model +
          "&sjhm=" +
          this.inputArr[1].model +
          "&syr=" +
          this.inputArr[0].model +
          "&sfzmhm=" +
          this.inputArr[2].model +
          "&clsbdh=" +
          this.inputArr[3].model +
          "&fdjh=" +
          this.inputArr[4].model +
          "&fdjxh=" +
          this.inputArr[5].model +
          "&zcxh=" +
          this.inputArr[6].model +
          "&sccs=" +
          this.inputArr[7].model +
          "&scqdbh=" +
          this.inputArr[9].model +
          "&ccrq=" +
          ccrq +
          "&rlzl=" +
          rlzl2 +
          "&ywlx=" +
          ywlx +
          "&xs4s=" +
          "xs4s" +
          "&shbm=" +
          shbm +
          "&clssd=" +
          jdcgsd;
      }
      url = encodeURI(encodeURI(url).replace(/\+/g, "%2B"));
      // console.log(url)
      // console.log("fLow/submit?tjr="+this.inputArr[0].model)
      // console.dir(formData)
      httpForm({
        method: "post",
        url: decodeURI(url),
        data: formData,
      })
        .then((result) => {
          that.$toast.clear();
          var response = result.data;
          if (response.status != "1") {
            if (that.isPc) {
              return that.$root.$children[0].vueAlert1(response.msg);
            } else {
              return that.$root.$children[0].vueAlert(response.msg);
            }
          }
          // localStorage.setItem("cxm", response.data.cxm);
          localStorage.setItem("ywlx", ywlx);
          // localStorage.setItem("cxm", response.data.cxm);
          this.$router.push("result");
        })
        .catch((err) => {
          console.log(err);
          that.$toast.clear();
        });
    },
    // 查询燃料种类
    getCode() {
      let that = this;
      let params = {
        xtlb: "01",
        ywlb: "0009",
      };
      this.$parent.showLoading();
      this.$get("common/queryCodeList", params).then((response) => {
        that.$toast.clear();
        let oldData = response.data;
        oldData.unshift({ dm: "", mc: "请选择" });
        let newData = [
          {
            values: oldData,
            className: "column1",
          },
          {
            values: oldData,
            className: "column2",
          },
          {
            values: oldData,
            className: "column3",
          },
        ];
        // console.log(newData)
        that.rlzlList = oldData;
        that.selectArr[0].data = that.isPc ? oldData : newData;
      });
    },
    // 查询审核部门
    getshbm() {
      let that = this;
      this.$get("dept/querySubDept", {}).then((response) => {
        that.selectArr[1].data = response.data;
        that.selectArr0[2].data = response.data;
      });
    },
    // 选择日期后触发
    timeConfirm(value) {
      this.currentDate = this.$root.$children[0].timeFomat("yyyy-MM", value);
      this.inputArr[8].model = this.currentDate;
      this.inputArr0[1].model = this.currentDate;
      this.timeShow = false;
    },
    // 图片预览
    picRead(e, index) {
      // console.log(e);
      // console.log(index);
      let _this = this;
      var files = e.target.files[0];
      if (!e || !window.FileReader) return; // 看支持不支持FileReader
      let reader = new FileReader();
      reader.readAsDataURL(files); // 这里是最关键的一步，转换就在这里
      reader.onloadend = function () {
        // console.log(this.result)
        _this.imgList[index].imageUrl = this.result;
        _this.imgList[index].image = e.target.files[0];
        console.log(_this.imgList);
      };
    },
    // 下面 都是失焦后保存输入选项（输入建议
    lostFocus(int) {
      this.currentFocus = "";
      // console.log(int)
      if (int.name == "提交人或4S店名称") {
        var int = { value: int.model };
        // this.restaurants.push
        if (!this.restaurants_mc.some((item) => item.value == int.value)) {
          this.restaurants_mc.push(int);
          // localStorage.setItem('')
          localStorage.setItem(
            "restaurants_mc",
            JSON.stringify(this.restaurants_mc)
          );
        }
      }
      if (int.name == "所有人身份证号或4S店统一社会信用代码") {
        var int = { value: int.model };
        if (!this.restaurants_dm.some((item) => item.value == int.value)) {
          this.restaurants_dm.push(int);
          localStorage.setItem(
            "restaurants_dm",
            JSON.stringify(this.restaurants_dm)
          );
        }
      }
      if (int.name == "车辆生产厂家") {
        var int = { value: int.model };
        // this.restaurants.push
        if (!this.restaurants_cj.some((item) => item.value == int.value)) {
          this.restaurants_cj.push(int);
          // localStorage.setItem('')
          localStorage.setItem(
            "restaurants_cj",
            JSON.stringify(this.restaurants_cj)
          );
        }
      }
    },
    querySearch_mc(queryString, cb) {
      var restaurants = this.restaurants_mc;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    querySearch_dm(queryString, cb) {
      var restaurants = this.restaurants_dm;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    querySearch_cj(queryString, cb) {
      var restaurants = this.restaurants_cj;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        if (restaurant.value) {
          // console.dir(restaurant)
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ==
            0
          );
        }
      };
    },
    handleSelect(item) {
      // console.log(item);
    },
    loadAll() {
      return [
        //  {value:''}
      ];
    },
  },
  mounted() {
    this.isPc = false;
    if (this.isPc) {
      // this.selectArr[1].model = '2'
      this.selectArr0[0].model = "2";
    } else {
      // this.selectArr[1].typeId = '2';
      // this.selectArr[1].model = '进口新车注册登记类'
      this.selectArr0[0].typeId = "2";
      this.selectArr0[0].model = "进口新车注册登记类";
    }
    // this.isPc?this.selectArr[1].model:this.selectArr[1].typeId;
    this.getCode();
    this.getshbm();
    // console.log(data)
    if (!JSON.parse(localStorage.getItem("restaurants_mc"))) {
      this.restaurants_mc = [];
    } else {
      this.restaurants_mc = JSON.parse(localStorage.getItem("restaurants_mc"));
    }
    if (!JSON.parse(localStorage.getItem("restaurants_dm"))) {
      this.restaurants_dm = [];
    } else {
      this.restaurants_dm = JSON.parse(localStorage.getItem("restaurants_dm"));
    }
    if (!JSON.parse(localStorage.getItem("restaurants_cj"))) {
      this.restaurants_cj = [];
    } else {
      this.restaurants_cj = JSON.parse(localStorage.getItem("restaurants_cj"));
    }

    console.log(this.$route.params);
    if (this.$route.params.sjhm) {
      this.inputArr[0].model = this.$route.params.tjr;
      this.inputArr[1].model = this.$route.params.sjhm;
      this.inputArr[2].model = this.$route.params.sfzmhm;
      this.inputArr[3].model = this.$route.params.clsbdh;
      this.inputArr[4].model = this.$route.params.fdjh;
      this.inputArr[5].model = this.$route.params.fdjxh;
      this.inputArr[6].model = this.$route.params.zcxh;
      this.inputArr[7].model = this.$route.params.sccs;
      this.inputArr[8].model = this.$route.params.ccrq;
      this.inputArr[9].model = this.$route.params.scqdbh;
    }
  },
};
</script>
<style scoped>
.submit {
  text-align: left;
}
.phone {
  margin-top: 6vh;
  padding: 2vh 3vw;
}
p {
  line-height: 5vh;
}
input {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  background: none;
  border: none;
  outline: none;
  color: rgb(198, 203, 212);
  border-bottom: 1px solid rgb(198, 203, 212);
  font-size: 16px;
  text-indent: 5px;
  box-sizing: border-box;
}
.el-autocomplete,
.el-date-editor,
.el-select {
  height: 6vh;
  line-height: 6vh;
}
.new_input {
  width: 100%;
}
.new_input .el-input__inner {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  background: none;
  border: none;
  outline: none;
  color: rgb(198, 203, 212);
  border-bottom: 1px solid rgb(198, 203, 212);
  font-size: 16px;
  text-indent: 5px;
}
>>> .el-autocomplete {
  width: 100%;
}
>>> .el-input__inner {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  background: none;
  border: none;
  outline: none;
  color: rgb(198, 203, 212);
  border-bottom: 1px solid rgb(198, 203, 212);
  font-size: 16px;
  text-indent: 5px;
}
.active {
  color: rgb(87, 96, 255);
}
input.active {
  color: rgb(87, 96, 255);
  border-bottom-color: rgb(87, 96, 255);
}
.upload {
  padding: 2vh 0;
}
.upload .img {
  position: relative;
  width: 100%;
  height: 25vh;
  border-radius: 6px;
  border: 1px dashed rgb(79, 87, 232);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload .img .up {
  width: 30%;
  margin: 4vh 35%;
  display: block;
  max-height: 10vh;
}

.aleade {
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
}
.file {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.pc {
  width: 70vw;
  height: 75vh;
  margin: 5vh 12vw;
  padding: 2vh 3vw;
  border-radius: 6px;
  background: #fff;
  overflow-y: scroll;
}
.pc .upload .img {
  width: 50%;
  margin-left: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pc .upload .img .up {
  margin: 4vh 35%;
  max-height: 10vh;
}
.motop {
  margin-top: 4vh;
}
.motop1 {
  margin-top: 0.5vh;
  overflow: hidden;
}
.mobottom {
  /* margin-bottom:-.5vh; */
}
span.red {
  color: red;
}
.wind100 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
}
.btn {
  width: 40%;
  margin-left: 21px;
}
.el-col {
  /* margin-top: 0.5vh; */
  /* margin-bottom: 0.5vh; */
}
</style>
